import { jsx } from 'react/jsx-runtime';
import { forwardRef, useContext } from 'react';
import { InputContext } from '../../Input/Input.Context/Input.Context.es.js';

const MultiSelectComboboxInner = /*#__PURE__*/ forwardRef(({ onChange, name, value, ...rest }, ref)=>{
    const { disabled, placeholder, readOnly, inputLabelId, inputMessageId } = useContext(InputContext);
    return jsx("input", {
        ref: ref,
        "aria-describedby": inputMessageId,
        "aria-labelledby": inputLabelId,
        className: "input",
        "data-testid": "multiselect-combobox-input",
        disabled: disabled,
        name: name,
        onChange: onChange,
        placeholder: placeholder,
        readOnly: readOnly,
        value: value,
        ...rest
    });
});
MultiSelectComboboxInner.displayName = 'MultiSelectCombobox.Inner';

export { MultiSelectComboboxInner, MultiSelectComboboxInner as default };
//# sourceMappingURL=MultiSelectCombobox.Inner.es.js.map
